// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AfmJ","controls":"styles_controls__UzkiS","charLimit":"styles_charLimit__2gjP6","input":"styles_input__XUTf1","send":"styles_send__278Cn"};